(() => {

  document.addEventListener('click', (event) => {

    const button = event.target.closest('[data-open-pack-modal]');

    if (!button) return;

    const handle = button.dataset.packHandle;

    let presets = [];

    try {

      presets =
        JSON.parse(
          button.dataset.presetProducts || '[]'
        );

    } catch (error) {

      presets = [];

    }

    document.dispatchEvent(new CustomEvent('digi:open-pack-modal', {
      detail: {
        handle,
        presets
      }
    }));

  });

  const grid = document.querySelector('.digi-packs-master__grid');

  if (!grid) return;

  const prev = document.querySelector('[data-packs-prev]');
  const next = document.querySelector('[data-packs-next]');

  function updateNav() {

    const maxScroll =
      grid.scrollWidth - grid.clientWidth;

    const current = grid.scrollLeft;

    prev.hidden = current <= 10;

    next.hidden = current >= (maxScroll - 10);

    // 🔥 esconde tudo se não houver overflow
    if (maxScroll <= 0) {
      prev.hidden = true;
      next.hidden = true;
    }

  }

function getScrollAmount() {

  const firstCard =
    grid.querySelector('.digi-pack-card');

  if (!firstCard) return 0;

  const cardWidth = firstCard.offsetWidth;

  const styles = getComputedStyle(grid);

  const gap =
    parseFloat(styles.columnGap || styles.gap || 0);

  // 3 cards + 3 gaps
  return (cardWidth * 3) + (gap * 3);

}

function scrollNext() {

  grid.scrollBy({
    left: getScrollAmount(),
    behavior: 'smooth'
  });

}

function scrollPrev() {

  grid.scrollBy({
    left: -getScrollAmount(),
    behavior: 'smooth'
  });

}

  next?.addEventListener('click', scrollNext);

  prev?.addEventListener('click', scrollPrev);

  grid.addEventListener('scroll', updateNav);

  window.addEventListener('resize', updateNav);

  updateNav();

})();